module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal proposal-link-view-modal animated fadeIn",
    class: {
      'is-active': _vm.$route.path.indexOf('/document-link') > -1
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('comments-float', {
    attrs: {
      "payload": _vm.payload
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card animated fadeInUp"
  }, [(!_vm.documentLoaded) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.documentLoaded && !_vm.deadLink) ? _c('document-part-cover', {
    attrs: {
      "payload": _vm.payload,
      "state": "view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.documentLoaded && !_vm.deadLink) ? _c('div', {
    staticClass: "document"
  }, _vm._l((_vm.payload.body), function(part, key) {
    return _c('div', {
      key: part.id
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column is-10 is-offset-1"
    }, [_c('div', {
      staticClass: "part-wrapper"
    }, [(part.type === 'h1') ? _c('document-part-h1', {
      attrs: {
        "part": part,
        "state": "view"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'h2') ? _c('document-part-h2', {
      attrs: {
        "part": part,
        "state": "view"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'h3') ? _c('document-part-h3', {
      attrs: {
        "part": part,
        "state": "view"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'text') ? _c('document-part-text', {
      attrs: {
        "part": part,
        "state": "view"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'bulleted-list') ? _c('document-part-bulleted-list', {
      attrs: {
        "part": part,
        "state": "view"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'numbered-list') ? _c('document-part-numbered-list', {
      attrs: {
        "part": part,
        "state": "view"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'image') ? _c('document-part-image', {
      attrs: {
        "part": part,
        "state": "view"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'table') ? _c('document-part-table', {
      attrs: {
        "part": part,
        "state": "view"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'module') ? _c('document-part-module', {
      attrs: {
        "part": part,
        "state": "view"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'pricing-table') ? _c('document-part-pricing-table', {
      attrs: {
        "part": part,
        "state": "view"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'page-break') ? _c('document-part-page-break', {
      attrs: {
        "state": "view"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'initials') ? _c('document-part-initials', {
      attrs: {
        "signatures": _vm.signatures,
        "part": part,
        "state": "view"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'signatures') ? _c('document-part-signatures', {
      attrs: {
        "signatures": _vm.signatures,
        "part": part,
        "viewer": _vm.viewer,
        "state": "view"
      }
    }) : _vm._e()], 1)])])])
  })) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10dbda48","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/document-link-view-modal.vue
// module id = 507
// module chunks = 0